import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    MINI_HEADER_BACK_LABEL: 'Voltar para tipos de folha',

    EMPTY_NO_ACCESS_TITLE: 'Você não tem acesso a esta tela',
    EMPTY_NO_ACCESS_DESCRIPTION:
      'Editar o pacote de conceitos é uma ação da equipe da Crehana.',

    ERROR_TITLE: 'Não foi possível carregar esta tela',
    ERROR_RETRY_BUTTON: 'Tentar novamente',

    BUTTON_CANCEL: 'Cancelar',

    EMPTY_CONCEPT_NOT_FOUND_TITLE: 'Este tipo de folha não existe',
    EMPTY_CONCEPT_NOT_FOUND_DESCRIPTION:
      'Pode ter sido excluído ou o link pode estar mal formado.',
    EMPTY_CONCEPT_NOT_FOUND_ACTION: 'Voltar para tipos de folha',

    COL_CODE: 'Código',
    COL_NAME: 'Nome',
    COL_ACTIONS: 'Ações',
    TABLE_TITLE: 'Conceitos do pacote',
    EMPTY_PACKAGE_TITLE: 'Este tipo de folha ainda não tem conceitos',
    EMPTY_PACKAGE_DESCRIPTION:
      'Adicione conceitos do catálogo para que este tipo de folha seja calculado.',
    TOOLTIP_REMOVE_CONCEPT: 'Remover do pacote',

    COL_ASSIGNMENT_TYPE: 'Tipo de atribuição',
    COL_ASSIGNMENT_ACTIVE: 'Atribuição ativa',
    ASSIGNMENT_TYPE_ALWAYS: 'Sempre',
    ASSIGNMENT_TYPE_ALWAYS_HINT: 'O motor calcula para todos.',
    ASSIGNMENT_TYPE_CONDITIONAL: 'Condicional',
    ASSIGNMENT_TYPE_CONDITIONAL_HINT:
      'Somente se houver uma incidência que o acione.',
    ASSIGNMENT_TYPE_OPTIONAL: 'Opcional',
    ASSIGNMENT_TYPE_OPTIONAL_HINT: 'Somente por captura manual do admin.',

    TWO_FLAGS_TITLE: 'Duas condições, não uma',
    TWO_FLAGS_BODY:
      'Um conceito só é calculado se estiver ativo no catálogo E sua atribuição estiver ativa. As duas são necessárias.',
    CATALOG_ACTIVE: 'Ativo no catálogo',
    CATALOG_INACTIVE: 'Inativo no catálogo',
    CALC_YES: 'Calcula',
    CALC_NO: 'Não calcula',
    CALC_YES_HINT:
      'O conceito está ativo no catálogo e sua atribuição está ativa.',
    CALC_NO_CATALOG_HINT:
      'Está atribuído e ativo, mas o conceito está inativo no catálogo.',
    CALC_NO_ASSIGNMENT_HINT:
      'O conceito está ativo no catálogo, mas esta atribuição está inativa.',
    CALC_NO_BOTH_HINT:
      'O conceito está inativo no catálogo, e a atribuição também.',
    CALC_UNKNOWN_HINT:
      'Não foi possível confirmar o status deste conceito no catálogo (índice truncado).',
    COL_CATALOG_ACTIVE: 'Ativo no catálogo (somente leitura)',
    COL_CALCULATES: 'Calcula',

    PICKER_LABEL: 'Adicionar conceito',
    PICKER_PLACEHOLDER: 'Selecione conceitos do catálogo',
    PICKER_ADD_BUTTON: 'Adicionar',
    PICKER_SELECT_ALL_VISIBLE: 'Selecionar tudo ({{count}})',
    PICKER_NO_RESULTS: 'Não encontramos conceitos com esse código ou nome',
    CATALOG_TRUNCATED:
      'O catálogo desta organização ultrapassa o que podemos mostrar aqui. Entre em contato com o suporte antes de continuar adicionando conceitos.',

    BUTTON_SAVE: 'Salvar alterações',
    SAVE_ERROR_TITLE: 'Não foi possível salvar o pacote',
    SAVE_UNEXPECTED_ERROR: 'Não foi possível salvar o pacote. Tente novamente.',
    TOAST_SAVED: 'Pacote de conceitos salvo',
    DISCARD_DIALOG_TITLE: 'Descartar alterações não salvas?',
    DISCARD_DIALOG_BODY: 'Você vai perder as alterações feitas neste pacote.',
    DISCARD_DIALOG_CONFIRM: 'Descartar',
  },
};
